/**
 * Menu Componenets
 *
 * @file menu.js
 */


 import $ from 'jquery';
const menu = (() => {
  // Services Page Project List
  const mobileLeftMenu = () => {
    if($(window).width() < 992){
      $(".left-menu h2.p-title").on("click", function(){
        $(this).next(".menu").toggle();
      });
    }
  };

  const init = () => {
    mobileLeftMenu();
  };

  return {
    init,
  };
})();

export default menu;
